/** Merges catalogs left-to-right; later entries override earlier keys. */
export function mergeCatalogs(...catalogs) {
    const out = {};
    for (const catalog of catalogs) {
        Object.assign(out, catalog);
    }
    return out;
}
//# sourceMappingURL=catalog.js.map